import { apiBaseUrl } from "../config/runtimeConfig";

// Absolute URL for a file in the office blob store.
//
// These used to be written out by hand against whatever hostname the API
// happened to answer on. That hostname then changed (the API moved behind
// Cloudflare at api.aregobrands.com) and the old literals kept pointing at the
// origin host we were trying to retire — a storefront image and the enrol/
// register background clips were still loading from it in production.
//
// apiBaseUrl comes from config.js (window.__APP_CONFIG__), which the container
// writes at startup from VITE_API_BASE_URL, so anything built through here
// follows the API wherever it moves next and nothing has to be edited again.
export function blobUrl(id) {
  const base = apiBaseUrl || "";
  return `${base}/api/v1/blobs/${id}`;
}
